import React, { useEffect } from 'react'
import i18n from 'simple-react-i18n'
import useBoolean from 'utils/customHook/useBoolean'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Icon, Tooltip } from '@mui/material'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import OperationAction from 'quality/components/operation/actions/OperationAction'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'
import { NewTable } from 'components/datatable/NewTable'

const CalculateParameters = ({
    operationIds = [],
}) => {
    const dispatch = useDispatch()
    const {
        qualitometer,
        calculateParameters,
    } = useSelector(store => ({
        qualitometer: store.QualityReducer.qualitometer,
        calculateParameters: store.OperationReducer.calculateParameters,
    }), shallowEqual)

    const {
        value: isOpen,
        setTrue: open,
        setFalse: close,
    } = useBoolean(false)

    useEffect(() => {
        dispatch(OperationAction.fetchCalculateParameters())
    }, [dispatch])

    const formattedParams = calculateParameters.filter(o => o.computedParameterCode).map(p => ({
        code: p.code,
        name: p.name ?? p.code,
        nbParameters: p.computedParameterCode.split(/;|,/).length,
    }))

    const onCalculate = () => {
        if (operationIds.length === 0 || isNil(qualitometer.id)) return
        dispatch(OperationAction.calculateParametersOperation(qualitometer.id, operationIds))
    }

    return (
        <div className='action-wrapper'>
            <Tooltip title={i18n.update} placement='bottom'>
                <Icon
                    sx={{ fontSize: '3rem', width: '69px', height: '64px', paddingTop: '12px', cursor: 'pointer' }}
                    onClick={open}
                >sync</Icon>
            </Tooltip>
            <Dialog
                maxWidth='md'
                fullWidth
                open={isOpen}
                slotProps={{
                    paper: {
                        sx: {
                            minHeight: undefined,
                            maxHeight: undefined,
                        },
                    },
                }}
            >
                <DefaultDialogTitle title={i18n.update} onClose={close} />
                <DialogContent>
                    {formattedParams.length === 0 && (<Card><CardContent><div className='center'> { i18n.noCalculateParameters }</div></CardContent></Card>)}
                    {formattedParams.length > 0 && (
                        <NewTable
                            rows={formattedParams}
                            headers={['code', 'name', 'nbParameters']}
                            maxHeight={275}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCalculate} variant='contained' color='primary' disabled={formattedParams.length === 0}>
                        {i18n.calculate}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

CalculateParameters.propTypes = {
    operationIds: PropTypes.arrayOf(PropTypes.number),
}

export default CalculateParameters